// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"PostForm_formGroup__1gQmz","formControl":"PostForm_formControl__XPTI4"};